import { Box } from "@chakra-ui/react";
import { useRef } from "react";
import { useUserData } from "../../../../hooks/useUserData";
import { SubmitForm } from "../../../../components/comment/SubmitForm";
import { SimpleLoginMenu } from "../../../../components/navigation/components/SimpleLoginMenu";
import { CommentsDisabled } from "../../../../components/comment/CommentsDisabled";

interface CommentFormProps {
  postReleaseComment: (message: string) => void;
  areCommentsDisabled?: boolean;
}
export function CommentForm({
  postReleaseComment,
  areCommentsDisabled,
}: CommentFormProps) {
  const formRef = useRef<HTMLInputElement>(null);
  const { userData } = useUserData();

  return (
    <Box
      height="96px"
      display="flex"
      justifyContent="center"
      alignItems={
        areCommentsDisabled ? "center" : userData ? "flex-start" : "center"
      }
      p="24px"
      position="sticky"
      width="100%"
      backdropFilter="blur(18px)"
      boxShadow="0px 4px 24px 0px rgba(0, 0, 0, 0.40)"
      bottom={0}
      right={0}
      flexDirection="column"
      marginTop="auto"
    >
      {areCommentsDisabled ? (
        <CommentsDisabled />
      ) : userData ? (
        <SubmitForm
          autoFocus
          handleSubmit={postReleaseComment}
          formRef={formRef}
          placeholder="Add a comment"
          isSmall
          noAvatar
        />
      ) : (
        <SimpleLoginMenu />
      )}
    </Box>
  );
}
